import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { MoneySuperMarketStacked, InterstitialZutoLogo, PoweredByZuto, MoneySuperMarketLarge } from '@zuto/icons'
import CheckedList from '../../CheckedList'
import AnimatedArrows from '../../Animations/AnimatedArrows'
import TrustBox from '../../TrustPilotHeader/TrustBox'

const list = [
  'Check your eligibility',
  'Car finance to suit all circumstances',
  'Get a decision in 60 seconds',
  'MoneySuperMarket\'s Car Finance partner'
]

const MoneySupermarketInterstitialContent = (): JSX.Element => {
  return (
    <>
        <Box sx={{ maxWidth: '360px', margin: ' 0 auto'}} pt="28px">
            <Grid className="interstitial-header" container spacing={1} columns={3} alignItems="center" justifyContent="space-between" mb={6}>
                <Grid><MoneySuperMarketStacked data-testid="moneysupermarketstacked-logo" /></Grid>
                <Grid><AnimatedArrows data-testid="animated-arrows" /></Grid>
                <Grid><InterstitialZutoLogo data-testid="zuto-interstitial-logo" /></Grid>
            </Grid>
            <Typography variant="rowHeading" color="#000" mb={4} fontSize={14}>Transferring you to car finance experts Zuto</Typography>
            <CheckedList list={list} darkerText />
            </Box>
            <Box mb={1} mt={11}>
                <Typography variant="bodyLarge" sx={{ fontSize: '16px', fontWeight: 700, textAlign: 'center'}}>Customers love Zuto&apos;s service</Typography>
            </Box>
            <Grid mt={4} mb={4} style={{ textAlign: 'center' }}>
                <TrustBox  />
            </Grid>
            <Box sx={{ 
                mt: 'auto', 
                mb: '28px', 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center',
                maxWidth: '360px',
                ml: 'auto',
                mr: 'auto',
                pt: 8
            }}>
            <MoneySuperMarketLarge data-testid="moneysupermarket-logo" style={{ marginBottom: '16px' }} />
            <Box sx={{ 
                display: 'flex', 
                width: '100%',
                justifyContent: 'flex-end' 
            }}>
                <PoweredByZuto data-testid="poweredbyzuto-logo" />
            </Box>
        </Box>
    </>
  )
}

export default MoneySupermarketInterstitialContent
